import React from "react";
import { COLORS } from "../constants/colors";
import Seo from "../components/Seo";
import "./TermsConditions.css";

function TermsConditions() {
  // const lastUpdated = new Date().toDateString();
    const lastUpdated = "22 December 2025";


  return (
    <div className="terms-container">
      <Seo title="Terms & Conditions — BudgetMate" description="Terms & Conditions for using BudgetMate — Smart Budget App." />
      <section className="terms-header">
        <h1 style={{ color: COLORS.primary }}>Terms & Conditions</h1>
        <p className="updated">
          <strong>Last updated:</strong> {lastUpdated}
        </p>
      </section>

      <section className="terms-content">
        <p>
          Welcome to <strong>BudgetMate – Smart Budget App</strong>. By downloading,
          accessing, or using this application, you agree to comply with and be
          bound by the following Terms & Conditions. If you do not agree, please
          do not use the app.
        </p>

        <h2>Use of the App</h2>
        <ul>
          <li>You are responsible for the accuracy of all data you enter.</li>
          <li>The app is intended for personal budgeting and expense tracking only.</li>
          <li>You agree not to misuse or attempt to disrupt app functionality.</li>
        </ul>

        <h2>User Responsibility</h2>
        <p>
          BudgetMate does not provide financial, investment, or legal advice.
          All financial decisions made based on app data are solely your
          responsibility.
        </p>

        <h2>Data & Availability</h2>
        <ul>
          <li>We strive to keep your data secure, but uninterrupted access is not guaranteed.</li>
          <li>Temporary downtime may occur due to maintenance or technical updates.</li>
          <li>You are advised to keep backups of important financial information.</li>
        </ul>

        <h2>Limitation of Liability</h2>
        <p>
          BudgetMate is provided on an “as is” and “as available” basis. We are
          not liable for any loss of data, financial loss, or damages resulting
          from the use or inability to use the app.
        </p>

        <h2>Intellectual Property</h2>
        <p>
          All content, design, logos, and branding related to BudgetMate are the
          property of BudgetMate and may not be copied or reused without written
          permission.
        </p>

        <h2>Changes to Terms</h2>
        <p>
          We may update these Terms & Conditions from time to time. Continued use
          of the app after updates means you accept the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          If you have any questions regarding these Terms & Conditions, please
          contact us at:
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:budgetmate1.app@zohomail.in">
            budgetmate1.app@zohomail.in
          </a>
        </p>
      </section>
    </div>
  );
}

export default TermsConditions;
